/**
 * SegmentedControl — 2–4 option pill switcher. Port of `NBTimeRange`,
 * generalized for any string-keyed enum (time range, density, view mode).
 *
 * A group of toggle buttons rather than tabs: picking an option changes what the
 * page shows, but there is no panel for a tab to own, so screen readers announced
 * "tab 2 of 4" with nothing behind it.
 */
export interface SegmentedControlOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string> {
  value: T;
  onChange: (next: T) => void;
  options: ReadonlyArray<SegmentedControlOption<T>>;
  ariaLabel?: string;
}

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  ariaLabel,
}: SegmentedControlProps<T>) {
  return (
    <div className="nb-seg" role="group" aria-label={ariaLabel}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
